import React from 'react';
import { useLang } from '../i18n/LangContext';
import { EXPERIENCE_KEYS } from '../data/content';
import { Bike, Landmark, Sparkles, Church, Waves, Footprints, Droplets, Shield, Leaf } from 'lucide-react';

const ICONS = {
  routes: Bike,
  stone: Landmark,
  stars: Sparkles,
  ermita: Church,
  reservoir: Waves,
  sentits: Footprints,
  oil: Droplets,
  trenches: Shield,
  mushrooms: Leaf,
};

export default function Experiences() {
  const { t } = useLang();
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
      {EXPERIENCE_KEYS.map((k) => {
        const Icon = ICONS[k];
        const it = t.experiences.items[k];
        return (
          <article
            key={k}
            className="group p-6 md:p-7 rounded-xl bg-white border border-[#EAE4DA] hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
          >
            <div className="h-11 w-11 rounded-full bg-[#EFEBDF] flex items-center justify-center text-[#606F51] mb-5">
              <Icon size={20} strokeWidth={1.6} />
            </div>
            <h3 className="font-serif text-[#2C2A26] text-xl md:text-[22px] leading-tight mb-3">
              {it.t}
            </h3>
            <p className="text-[#6b6558] text-sm md:text-[15px] leading-relaxed">
              {it.d}
            </p>
          </article>
        );
      })}
    </div>
  );
}
